
import './App.css';
import Home from './components/home/Home.js';
function App() {

  return (
    <div className="">
      <Home></Home>

    </div>
  );
}

export default (App);
